import React, { useEffect, useState } from 'react';
import api from '../api/axios';


import { FaBalanceScale, FaSave } from 'react-icons/fa';

const TaxSettings = () => {
  const [threshold, setThreshold] = useState('');
  const [rate, setRate] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');



  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get('/tax/settings');
        setThreshold(res.data.threshold_limit);
        setRate(res.data.tax_percentage);
      } catch (err) {
        console.error(err);
        const errMsg = err.response?.data?.detail || 'Failed to load settings';
        setMessage(errMsg);
        setMessageType('error');
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    try {
      const payload = {
        threshold_limit: Number(threshold),
        tax_percentage: Number(rate),
      };
      await api.put('/tax/settings', payload);
      setMessage('Settings saved successfully');
      setMessageType('success');
    } catch (err) {
      console.error(err);
      const errMsg = err.response?.data?.detail || 'Error saving settings';
      setMessage(errMsg);
      setMessageType('error');
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      {/* Page Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '24px',
      }}>
        <div style={{
          width: '42px',
          height: '42px',
          borderRadius: '10px',
          background: 'linear-gradient(135deg, #00aaff, #0077cc)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: '18px',
        }}>
          <FaBalanceScale />
        </div>
        <div>
          <h4 style={{ margin: 0, color: '#1a1a2e', fontWeight: '600' }}>Corporate Tax Settings</h4>
          <p style={{ margin: 0, fontSize: '13px', color: '#888' }}>Configure tax threshold and percentage</p>
        </div>
      </div>

      {/* Card */}
      <div style={{
        background: '#fff',
        borderRadius: '12px',
        border: '1px solid #e0f0ff',
        padding: '28px',
        maxWidth: '600px',
        boxShadow: '0 2px 12px rgba(0, 119, 204, 0.06)',
      }}>
        {/* Threshold */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            marginBottom: '6px',
            fontWeight: '500',
            color: '#333',
            fontSize: '14px',
          }}>
            Profit Threshold Limit (AED)
          </label>
          <input
            type="number"
            value={threshold}
            onChange={(e) => setThreshold(e.target.value)}
            placeholder="e.g. 375000"
            style={{
              width: '100%',
              padding: '10px 14px',
              borderRadius: '8px',
              border: '1px solid #d0e8ff',
              background: '#f8fbff',
              color: '#333',
              fontSize: '14px',
              outline: 'none',
              transition: 'border-color 0.2s',
            }}
            onFocus={(e) => e.target.style.borderColor = '#00aaff'}
            onBlur={(e) => e.target.style.borderColor = '#d0e8ff'}
          />
        </div>

        {/* Rate */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{
            display: 'block',
            marginBottom: '6px',
            fontWeight: '500',
            color: '#333',
            fontSize: '14px',
          }}>
            Tax Percentage (%)
          </label>
          <input
            type="number"
            step="0.01"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            placeholder="e.g. 9"
            style={{
              width: '100%',
              padding: '10px 14px',
              borderRadius: '8px',
              border: '1px solid #d0e8ff',
              background: '#f8fbff',
              color: '#333',
              fontSize: '14px',
              outline: 'none',
              transition: 'border-color 0.2s',
            }}
            onFocus={(e) => e.target.style.borderColor = '#00aaff'}
            onBlur={(e) => e.target.style.borderColor = '#d0e8ff'}
          />
        </div>

        {/* Save Button */}
        <button
          onClick={handleSave}
          style={{
            background: 'linear-gradient(135deg, #00aaff, #0077cc)',
            border: 'none',
            color: '#fff',
            padding: '10px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'opacity 0.2s',
          }}
          onMouseEnter={(e) => e.target.style.opacity = '0.9'}
          onMouseLeave={(e) => e.target.style.opacity = '1'}
        >
          <FaSave /> Save Settings
        </button>

        {/* Message */}
        {message && (
          <div style={{
            marginTop: '16px',
            padding: '10px 14px',
            borderRadius: '8px',
            background: messageType === 'success' ? '#e6f9ee' : '#fff0f0',
            color: messageType === 'success' ? '#0a8a3e' : '#d32f2f',
            border: `1px solid ${messageType === 'success' ? '#b2e8c8' : '#ffc5c5'}`,
            fontSize: '14px',
            fontWeight: '500',
          }}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default TaxSettings;
